import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import Container from '../../../components/structure/Container'
import ControlBar from './ControlBar'
import FormLoader from './_load/FormLoader'
import FormRepliesLoader from './_load/FormRepliesLoader'
import FormRepliesTable from './table/FormRepliesTable'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'

const Page = ({ id }) => (
  <AbsolutePageTemplate bgColor={COLORS.white}>
    <PermissionChecker permission="listForm">
      <FormLoader id={id}>
        <PageHeader />
        <Separator weight={4} />

        <Container>
          <FilterHandler tempStorageNamespace="formReplies" initialState={{}}>
            <MultiSelectHandler>
              <ControlBar />
              <FormRepliesLoader uncontrolledChildren={<MultiRowsActions />}>
                <FormRepliesTable />
              </FormRepliesLoader>
            </MultiSelectHandler>
          </FilterHandler>
          <Separator weight={5} />
        </Container>
      </FormLoader>
    </PermissionChecker>
  </AbsolutePageTemplate>
)

export default Page
